import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Nav } from 'react-bootstrap-5';
import Overview from './property_detail_tabs/overview';
import SimilarProperties from './property_detail_tabs/similar_properties';
import Lists from './property_detail_tabs/lists';
import { deleteCallListItem } from '../../helpers/connect_api';

const TAB_OVERVIEW = 'overview';
const TAB_SIMILAR_PROPERTIES = 'similar_properties';
const TAB_LISTS = 'lists';

export default function PropertyDetails({ initialCallListItems, insightsPropertyId }) {
  const [tab, setTab] = useState(TAB_OVERVIEW);
  const [callListItems, setCallListItems] = useState(initialCallListItems);

  const handleCallListItemDelete = (callListItem) => {
    deleteCallListItem(callListItem.id)
      .then(setCallListItems(prevCallListItem => prevCallListItem.filter(item => item.id !== callListItem.id)));
  };

  return (
    <Card>
      <Card.Header className="border-bottom-0">
        <h5 className="fw-bolder mb-0">Property Details</h5>
      </Card.Header>
      <Nav activeKey={tab} variant="tabs" onSelect={setTab}>
        <Nav.Item>
          <Nav.Link className="border-start-0" eventKey={TAB_OVERVIEW}>
            Overview
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey={TAB_SIMILAR_PROPERTIES}>
            Similar Properties
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey={TAB_LISTS}>
            Lists ({callListItems.length})
          </Nav.Link>
        </Nav.Item>
      </Nav>
      <Card.Body>
        {tab === TAB_OVERVIEW && <Overview insightsPropertyId={insightsPropertyId} />}
        {tab === TAB_SIMILAR_PROPERTIES && <SimilarProperties insightsPropertyId={insightsPropertyId} />}
        {tab === TAB_LISTS && <Lists callListItems={callListItems} onDelete={handleCallListItemDelete} />}
      </Card.Body>
    </Card>
  );
}

PropertyDetails.propTypes = {
  initialCallListItems: PropTypes.array.isRequired,
  insightsPropertyId: PropTypes.number.isRequired
};
